import { render } from "./MonthSaleRemain.vue?vue&type=template&id=072aba54&scoped=true"
import script from "./MonthSaleRemain.vue?vue&type=script&lang=js"
export * from "./MonthSaleRemain.vue?vue&type=script&lang=js"

import "./MonthSaleRemain.vue?vue&type=style&index=0&id=072aba54&scoped=true&lang=css"

import exportComponent from "D:\\AICodeSpace\\KaungAdmin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-072aba54"]])

export default __exports__